// import "intersection-observer"
import { bridge } from '@/common/bridge/methods'
import { BRIDGE_METHODS } from '@/common/bridge/constants'
import { router } from '@/router'

// 节流时间调整，默认100ms
IntersectionObserver.prototype['THROTTLE_TIMEOUT'] = 300

export default class Exposure {
  constructor() {
    this._observer = null
    this.exposureTimers = new Map() // 存储元素曝光开始时间
    this.init()
    this.bindPageEvents()
  }

  init() {
    const self = this

    // 实例化监听
    this._observer = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(entry => {
          // 出现在视窗内
          if (entry.isIntersecting) {
            // 获取参数
            let traceKey = entry.target.getAttribute('trace-key-exposure')
            if (!traceKey && entry.target.hasAttribute('trace-key')) {
              traceKey = entry.target.getAttribute('trace-key')
            }
            const traceVal = entry.target.attributes['track-params'].value

            // 记录曝光开始时间
            if (!self.exposureTimers.has(entry.target)) {
              self.exposureTimers.set(entry.target, {
                startTime: Date.now(),
                traceKey,
                traceVal,
              })
            }
          } else {
            // 目前只做整体页面曝光，暂时return
            return
            // 元素离开视窗，计算曝光时长
            if (self.exposureTimers.has(entry.target)) {
              const exposureData = self.exposureTimers.get(entry.target)
              // 曝光时长统计（毫秒）
              const exposureDuration = Date.now() - exposureData.startTime
              const traceVal = JSON.parse(exposureData.traceVal)
              Reflect.set(traceVal, 'exposureDuration', exposureDuration)
              self.track(exposureData.traceKey, traceVal)

              // 清除计时器
              self.exposureTimers.delete(entry.target)

              // 离开视窗取消观察，如果注释，下次进入视窗会重新观察上报
              self._observer.unobserve(entry.target)
            }
          }
        })
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1, // 元素出现面积，0 - 1，这里当元素出现一半以上则进行曝光
      }
    )
  }

  // 绑定页面事件，处理页面卸载和路由跳转
  bindPageEvents() {
    // 页面卸载前上报所有正在曝光的元素 地址栏修改路由跳转、刷新、后退、前进
    window.addEventListener('beforeunload', () => {
      this.reportAllExposures()
    })

    window.addEventListener('pagehide', () => {
      this.reportAllExposures()
    })

    // 页面隐藏时上报（移动端切换应用、最小化等）
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.reportAllExposures()
      }
    })

    // vuerouter路由跳转
    router.beforeEach((to, from) => {
      this.reportAllExposures()
      return true
    })
  }

  // 上报所有正在曝光的元素
  reportAllExposures() {
    this.exposureTimers.forEach((exposureData, element) => {
      const exposureDuration = Date.now() - exposureData.startTime
      const traceVal = JSON.parse(exposureData.traceVal)
      Reflect.set(traceVal, 'exposureDuration', exposureDuration)
      this.track(exposureData.traceKey, traceVal)
      this._observer.unobserve(element)
    })
    this.exposureTimers.clear()
  }

  // 元素添加监听
  add(entry) {
    this._observer && this._observer.observe(entry.el)
  }

  // 埋点上报
  track(traceKey, traceVal) {
    console.log('曝光埋点', {
      type: 'onEvent',
      name: traceKey,
      params: traceVal,
    })
    bridge.invokeSync(BRIDGE_METHODS.SEND_TRACK, {
      type: 'onEvent',
      name: traceKey,
      params: traceVal,
    })
  }

  // 清理所有计时器
  clear() {
    this.reportAllExposures()
    if (this._observer) {
      this._observer.disconnect()
    }
  }
}
